
import Overlay from '../../../components/Overlay.vue';
import { PieChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent,
} from 'echarts/components';
import { use } from 'echarts/core';
import { CanvasRenderer, SVGRenderer } from 'echarts/renderers';
import { defineComponent, ref, toRefs } from 'vue';
import VChart from 'vue-echarts';

use([
  PieChart,
  CanvasRenderer,
  SVGRenderer,
  GridComponent,
  TooltipComponent,
  TitleComponent,
  LegendComponent,
]);

export default defineComponent({
  name: 'DashboardBilledReserved',

  components: {
    Overlay,
    VChart,
  },

  props: {
    billed: {
      type: Number,
      default: 0,
    },

    reserved: {
      type: Number,
      default: 0,
    },

    picked: {
      type: Number,
      default: 0,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    segmento: {
      type: Number,
      default: 1,
    },

    segmentName: {
      type: String,
      default: '',
    },
  },

  setup(props) {
    const propsRefs = toRefs(props);

    const formatter = (value: any) => {
      if (value === 0) return '0';

      return value.toLocaleString();
    };

    const options = ref({
      legend: {
        show: true,
        orient: 'horizontal',
        bottom: 'bottom',
        textStyle: {
          fontSize: 16,
          fontFamily: 'Helvetica Neue Condense, sans-serif',
        },
      },
      series: [
        {
          stillShowZeroSum: false,
          name: 'Acessórios + Confecção',
          type: 'pie',
          radius: '55%',
          label: {
            show: true,
            fontSize: 16,
            fontWeight: 'bold',
          },
          data: [
            {
              value: propsRefs.reserved,
              name: 'Reservado',
              label: {
                formatter: ({ value }) => formatter(value),
              },
              itemStyle: {
                color: '#00AFD7',
              },
            },
            {
              value: propsRefs.picked,
              name: 'Coletado',
              label: {
                formatter: ({ value }) => formatter(value),
              },
              itemStyle: {
                color: '#FFC700',
              },
            },
            {
              value: propsRefs.billed,
              name: 'Faturado',
              label: {
                formatter: ({ value }) => formatter(value),
              },
              itemStyle: {
                color: '#FF6A13',
              },
            },
          ],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        },
      ],
    });

    return { options };
  },
});
